import { LoginErrorPage } from './LoginErrorPage';
import { useLoginErrorPageViewModel } from './useLoginErrorPageViewModel';

export function LoginErrorPageWrapper() {
  const props = useLoginErrorPageViewModel();

  return <LoginErrorPage {...props} />;
}
